export enum CarStatus {
  AVAILABLE = 'Available',
  PENDING = 'Pending',
  SOLD = 'Sold'
}

export interface Car {
  id: string;
  make: string;
  model: string;
  year: number;
  price: number;
  mileage: number;
  color: string;
  vin: string;
  description: string;
  features: string[];
  images: string[];
  status: CarStatus;
  featured: boolean;
  category: 'SUV' | 'Sedan' | 'Truck' | 'Coupe' | 'Luxury';
}

export interface TestDriveRequest {
  id: string;
  carId: string;
  carName: string; // Denormalized for display convenience
  customerName: string;
  email: string;
  phone: string;
  preferredDate: string;
  preferredTime: string;
  status: 'Pending' | 'Confirmed' | 'Completed';
}

export interface CarRequest {
  id: string;
  name: string;
  email: string;
  phone: string;
  make: string;
  model: string;
  yearRange: string;
  priceRange: string;
  message: string;
  status: 'New' | 'Contacted' | 'Fulfilled';
}

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'sales_manager' | 'staff';
  createdAt: string;
}